import Common from '../common.js';

export default {

    appealSubjects: function (municipalityId, async, successCallback, errorCallback) {

        let queryParams = '?municipalityId=' + municipalityId;
        var d = null;
        $.ajax({
            url: Application.getBasePath() + '/api/appeal/subject' + queryParams,
            type: 'GET',
            dataType: "json",
            async: async,
            contentType: 'application/json', xhrFields: {withCredentials: true},
            success: function (data, textStatus) {
                d = data;
                if (successCallback != null) {
                    successCallback(data);
                }
            },
            error: function (jqXHR, data, textStatus) {
                var obj = jQuery.parseJSON(jqXHR.responseText);
                if (errorCallback != null) {
                    errorCallback(obj.message);
                }
            }
        });

        return d;
    },


};


// WEBPACK FOOTER //
// ./src/api/appealSubjectApi.js